/**
 * Show a notification through the phone / computer while Eaze is in the
 * background (the device stacks them by app, like any other). Only after the
 * person allowed it; otherwise nothing happens. Clicking one opens Eaze on
 * the right page (public/sw.js → notificationclick).
 */
export const canNotify = () => typeof window !== "undefined" && "Notification" in window;
export const notifyPermission = (): NotificationPermission | "unsupported" => (canNotify() ? Notification.permission : "unsupported");

export async function askToNotify(): Promise<NotificationPermission | "unsupported"> {
  if (!canNotify()) return "unsupported";
  if (Notification.permission !== "default") return Notification.permission;
  try {
    return await Notification.requestPermission();
  } catch {
    return Notification.permission;
  }
}

export async function showSystemNotification({ title, body, tag, url }: { title: string; body: string; tag: string; url: string }) {
  if (!canNotify() || Notification.permission !== "granted") return false;
  const opts: NotificationOptions & { renotify?: boolean } = { body, tag, icon: "/icons/icon-192x192.png", badge: "/icons/icon-96x96.png", data: { url } };
  try {
    const reg = "serviceWorker" in navigator ? await navigator.serviceWorker.getRegistration() : undefined;
    if (reg) {
      await reg.showNotification(title, { ...opts, renotify: true } as NotificationOptions);
      return true;
    }
    const n = new Notification(title, opts);
    n.onclick = () => {
      window.focus();
      window.location.assign(url);
    };
    return true;
  } catch {
    return false;
  }
}
